// @flow
import React, { Fragment } from 'react';
import LetterCard from 'components/common/LetterCard';
import type { LetterItem } from 'store/modules/lettering';
import FakeLetterCard from 'components/common/FakeLetterCard';
import './LetterCardList.scss';

type Props = {
  letters?: ?(LetterItem[]),
  loading: boolean,
  prefetching: boolean,
  width?: number,
  hasEnded: boolean,
  oneColumn?: boolean,
  placeholderCount?: number,
  hideUsername?: boolean,
  isTrending?: boolean,
};

const createArray = length => Array.from(Array(length).keys());
const getColumnCount = width => {
  const xWide = 1920;
  const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 1;

  if (width < medium) return 4;
  if (width < large) return 6;
  if (width < xLarge) return 6;
  if (width < wide) return 6;
  if (width < xWide) return 12;
  return 12;
};

const getTrendingCount = width => {
  // const xWide = 1920;
  // const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 4;

  if (width < medium) return 4;
  if (width <= large) return 6;
  if (width <= xLarge) return 8;
  // if (width <= wide) return 8;
  // if (width <= xWide) return 10;
  return 10;
};

const LetterCardList = ({
  letters,
  loading,
  prefetching,
  width,
  hasEnded,
  oneColumn,
  isTrending,
}: Props) => {
  const trendingCount = getTrendingCount(width);
  if (loading) {
    return (
      <div className="LetterCardList">
        {createArray(trendingCount).map(num => (
          <FakeLetterCard key={num} oneColumn={oneColumn} />
        ))}
      </div>
    );
  }

  const columnCount = oneColumn ? 1 : getColumnCount(width);
  if (!letters) return null;
  const TrendingList = isTrending ? letters.slice(0, trendingCount) : letters;
  const letterList = (hasEnded || letters.length <= 10
    ? TrendingList
    : letters.slice(0, letters.length - (letters.length % columnCount))
  ).map(letter => (
    <LetterCard
      key={letter.id}
      id={letter.id}
      thumbnail={letter.thumbnail}
      title={letter.title}
      urlSlug={letter.url_slug}
      oneColumn={oneColumn}
      shortDescription={letter.meta.short_description}
    />
  ));

  return (
    <Fragment>
      <div className="LetterCardList">
        {letterList && letterList.length === 0 && (
          <div className="empty-list">아직 등록된 뉴스레터가 없습니다.</div>
        )}
        {letterList}
        {prefetching &&
          createArray(columnCount).map(num => <FakeLetterCard key={num} oneColumn={oneColumn} />)}
      </div>
    </Fragment>
  );
};

LetterCardList.defaultProps = {
  letters: [],
  oneColumn: false,
  width: 0,
  placeholderCount: 12,
  hideUsername: false,
};

export default LetterCardList;



// WEBPACK FOOTER //
// ./src/components/common/LetterCardList/LetterCardList.js